var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2338_4851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: -0.203125,
    y: -0.564941,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2338_4851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lock_2",
    d: "M5.79688 21.4351C5.24688 21.4351 4.77604 21.2392 4.38438 20.8476C3.99271 20.4559 3.79688 19.9851 3.79688 19.4351V9.43506C3.79688 8.88506 3.99271 8.41423 4.38438 8.02256C4.77604 7.63089 5.24688 7.43506 5.79688 7.43506H6.79688V5.43506C6.79688 4.05173 7.28438 2.87256 8.25938 1.89756C9.23438 0.922559 10.4135 0.435059 11.7969 0.435059C13.1802 0.435059 14.3594 0.922559 15.3344 1.89756C16.3094 2.87256 16.7969 4.05173 16.7969 5.43506V7.43506H17.7969C18.3469 7.43506 18.8177 7.63089 19.2094 8.02256C19.601 8.41423 19.7969 8.88506 19.7969 9.43506V19.4351C19.7969 19.9851 19.601 20.4559 19.2094 20.8476C18.8177 21.2392 18.3469 21.4351 17.7969 21.4351H5.79688ZM5.79688 19.4351H17.7969V9.43506H5.79688V19.4351ZM11.7969 16.4351C12.3469 16.4351 12.8177 16.2392 13.2094 15.8476C13.601 15.4559 13.7969 14.9851 13.7969 14.4351C13.7969 13.8851 13.601 13.4142 13.2094 13.0226C12.8177 12.6309 12.3469 12.4351 11.7969 12.4351C11.2469 12.4351 10.776 12.6309 10.3844 13.0226C9.99271 13.4142 9.79688 13.8851 9.79688 14.4351C9.79688 14.9851 9.99271 15.4559 10.3844 15.8476C10.776 16.2392 11.2469 16.4351 11.7969 16.4351ZM8.79688 7.43506H14.7969V5.43506C14.7969 4.60173 14.5052 3.89339 13.9219 3.31006C13.3385 2.72673 12.6302 2.43506 11.7969 2.43506C10.9635 2.43506 10.2552 2.72673 9.67188 3.31006C9.08854 3.89339 8.79688 4.60173 8.79688 5.43506V7.43506Z",
    fill: "#54585B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7186ffeded58b338ffa836ddc8db3932.svg";
export { ForwardRef as ReactComponent };